import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=4c546ba5&"
import script from "./ContentView.vue?vue&type=script&lang=js&"
export * from "./ContentView.vue?vue&type=script&lang=js&"
import style0 from "./ContentView.vue?vue&type=style&index=0&id=4c546ba5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports